// Delete the former reusable password without reading or transmitting it.
export function clearLegacyAdminStorage() {
  try { window.localStorage.removeItem('dv_admin_auth'); } catch { /* storage may be disabled */ }
}
